import { render } from "./ChartReviews.vue?vue&type=template&id=14a64f6a&scoped=true"
import script from "./ChartReviews.vue?vue&type=script&lang=js"
export * from "./ChartReviews.vue?vue&type=script&lang=js"

import "./ChartReviews.vue?vue&type=style&index=0&id=14a64f6a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a64f6a"]])

export default __exports__